'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _omit2 = require('lodash/omit');

var _omit3 = _interopRequireDefault(_omit2);

var _isArray2 = require('lodash/isArray');

var _isArray3 = _interopRequireDefault(_isArray2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var unpack = function unpack() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$parentField = _ref.parentField,
      parentField = _ref$parentField === undefined ? 'parent' : _ref$parentField,
      _ref$childrenField = _ref.childrenField,
      childrenField = _ref$childrenField === undefined ? 'children' : _ref$childrenField,
      _ref$idField = _ref.idField,
      idField = _ref$idField === undefined ? 'id' : _ref$idField,
      parent = _ref.parent;

  return function (rows) {
    var _ref2;

    if (!(0, _isArray3.default)(rows)) {
      return [];
    }

    if (!rows.length) {
      return rows;
    }

    return (_ref2 = []).concat.apply(_ref2, _toConsumableArray(rows.map(function (node) {
      var children = node[childrenField];
      var d = parent ? _extends({}, (0, _omit3.default)(node, childrenField), _defineProperty({}, parentField, parent)) : (0, _omit3.default)(node, childrenField);

      if (children) {
        d._isParent = true;
      }

      return [d].concat(unpack({
        parentField: parentField,
        parent: d[idField],
        idField: idField
      })(children));
    })));
  };
};

exports.default = unpack;